<template>
  <div :id="id" class="pfexcel-dropdown-container">
    <div class="pfexcel-dropdown-title" @click="openParentDD">
      {{ parsedTitle }}
    </div>
    <div :id="'pfexcel-dropdown-wrapper' + _uid" class="pfexcel-dropdown-wrapper">
      <div v-for="(item, index) in parentOptions" :key="index" class="pfexcel-dropdown-item" :class="getParentClasses(item, index)" @click="selectedParentItem(item.name, index)">
        {{ item.name }}
      </div>
      <div :id="'pfexcel-dropdown-child-wrapper' + _uid" class="pfexcel-dropdown-wrapper pfexcel-dropdown-child">
        <div v-for="(item2, index2) in childOptions" :key="'child_' + index2" class="pfexcel-dropdown-item" @click="selectChildItem(item2)">
          {{ item2.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'
export default {
  name: 'PfExceldropdown',
  props: {
    selSection: {
      type: String,
      default: ''
    },
    selTitle: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    matchedcols: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      id: null,
      selectedParent: null,
      currentOffsetTop: null,
      currentOffsetLeft: null
    }
  },
  computed: {
    parsedTitle: function() {
      if (this.selTitle === '' && this.selSection === '') { return 'Select...' }
      return (this.selTitle !== '' && !!this.selTitle) ? (this.selSection + ' - ' + this.selTitle) : this.selSection
    },
    uniqueParents: function() {
      var arr = []
      var clearOpt = _.filter(this.options, function(item) { return item.columns === null || item.columns === undefined || item.columns.length === 0 })
      clearOpt.map(function(item) {
        arr.push(item.header.Name)
      })
      return arr
    },
    parentOptions: function() {
      var arr = []
      this.options.map(function(item) {
        arr.push({
          name: item.header.Name,
          isId: item.columns === undefined || item.columns === null || item.columns.length === 0
        })
      })
      return arr
    },
    childOptions: function() {
      var vm = this
      var selArr = _.filter(this.options, function(item) { return item.header.Name === vm.selectedParent })

      if (!!selArr && selArr.length > 0) {
        var cleanOpts = selArr[0].columns
        if (this.matchedcols.length !== 0) {
          cleanOpts = _.filter(cleanOpts, function(item) { return !vm.matchedcols.some(s => s.brainsTitle === item.title) })
        }

        return cleanOpts
      } else {
        return []
      }
    }
  },
  created() {
    this.id = 'pfExceldropdown' + this._uid
  },
  mounted() {
    var vm = this
    window.addEventListener('mousedown', function(e) {
      var item = document.getElementById('pfexcel-dropdown-wrapper' + vm._uid)
      if (item && !item.contains(e.target) && !document.getElementById(vm.id).contains(e.target)) {
        document.getElementById('pfexcel-dropdown-wrapper' + vm._uid).style.display = 'none'
        document.getElementById('pfexcel-dropdown-child-wrapper' + vm._uid).style.display = 'none'

        this.selectedParent = null
        Array.from(document.querySelectorAll('.pfexcel-dropdown-item--selected'))
          .forEach((el) => el.classList.remove('pfexcel-dropdown-item--selected'))
      }
    })
  },
  methods: {
    getParentClasses(item, index) {
      return ('pfexcel-dropdown-item' + item.name.replace(' ', '') + index) + ' ' + (item.isId ? 'pfexcel-dropdown-item--isid' : '')
    },
    openParentDD() {
      var containerDOM = document.getElementById(this.id)
      var moveDOM = document.getElementById('pfexcel-dropdown-wrapper' + this._uid)
      var offLeft = (containerDOM.getBoundingClientRect().left + 5)
      var offTop = (containerDOM.getBoundingClientRect().top - containerDOM.getBoundingClientRect().height + 4)

      moveDOM.style.left = offLeft + 'px'
      moveDOM.style.top = offTop + 'px'
      moveDOM.style.minWidth = (containerDOM.getBoundingClientRect().width - 10) + 'px'
      moveDOM.style.display = 'block'

      this.currentOffsetTop = offTop
      this.currentOffsetLeft = offLeft

      this.$emit('input', { parent: null, child: null, childID: null })
    },
    selectedParentItem(item, index) {
      Array.from(document.querySelectorAll('.pfexcel-dropdown-item--selected'))
        .forEach((el) => el.classList.remove('pfexcel-dropdown-item--selected'))

      if (this.uniqueParents.includes(item)) {
        document.getElementById('pfexcel-dropdown-wrapper' + this._uid).style.display = 'none'
        document.getElementById('pfexcel-dropdown-child-wrapper' + this._uid).style.display = 'none'
        this.selectedParent = null

        this.$emit('input', { parent: item, child: null, childID: null })
      } else {
        this.selectedParent = item
        var selItm = document.querySelector('#pfexcel-dropdown-wrapper' + this._uid + ' > .pfexcel-dropdown-item' + item.replace(' ', '') + index)
        if (selItm) { selItm.classList.add('pfexcel-dropdown-item--selected') }
        var childDOM = document.getElementById('pfexcel-dropdown-child-wrapper' + this._uid)
        childDOM.style.display = 'block'

        setTimeout(() => {
          if (window.innerHeight < (this.currentOffsetTop + childDOM.offsetHeight)) {
            childDOM.style.top = 'auto'
            childDOM.style.bottom = 0
          } else {
            childDOM.style.bottom = 'auto'
            childDOM.style.top = 0
          }
          if (window.innerWidth < (this.currentOffsetLeft + childDOM.offsetLeft + childDOM.offsetWidth)) {
            childDOM.style.right = 'calc(100% + 10px)'
            childDOM.style.left = 'auto'
          } else {
            childDOM.style.left = 'calc(100% + 10px)'
            childDOM.style.right = 'auto'
          }
        }, 50)
      }
    },
    selectChildItem(item) {
      document.getElementById('pfexcel-dropdown-wrapper' + this._uid).style.display = 'none'
      document.getElementById('pfexcel-dropdown-child-wrapper' + this._uid).style.display = 'none'

      this.$emit('input', { parent: this.selectedParent, child: item.title, childID: item.id })
      this.selectedParent = null
    }
  }
}
</script>

<style lang="scss" scoped>
.pfexcel-dropdown-container {
  height: 100%;
  width: 100%;

  .pfexcel-dropdown-title {
    height: 100%;
    font-size: 13px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-family: 'Montserrat-SemiBold',sans-serif;
    cursor: pointer;
  }

  .pfexcel-dropdown-wrapper {
    position: absolute;
    display: none;
    background-color: white;
    border: 1px solid lightgrey;
    color: black;
    z-index: 2000;
    box-shadow: 1px 1px 4px 1px lightgrey;

    .pfexcel-dropdown-item {
      padding: 5px 10px;
      cursor: pointer;

      &:hover {
        background-color: #1e3cffb0;
        color: white;
      }

      &--selected {
        background-color: #1e3cff;
        color: white;
      }

      &--isid:hover {
        background-color: #009999;
      }
    }
  }

  .pfexcel-dropdown-child {
    left: calc(100% + 10px);
    top: 0;
  }

}
</style>
